import axios from 'axios';

export enum FileType {
    Pdf = "pdf",
    Xls = "xls"
}

export interface StorageFile {
    id: number,
    title: string,
    public_path: string
}

export const saveFile = async (file: File, fileType: FileType) => {
    const formData = new FormData();
    formData.append('file', file);

    const url = `/api/media/${fileType}`;

    return (await axios.post(url, formData)).data as StorageFile;
};

export const deleteFile = async (file: StorageFile) => {
    const url = `/api/media/${file.id}`;

    return await axios.delete(url);
};

export const getFile = async (fileId: number) => {
    const url = `/api/media/${fileId}`;

    return (await axios.get(url)).data as StorageFile;
};

export const getUnattachedFile = async (fileType: FileType) => {
    const url = `/api/media/${fileType}/unattached`;

    const result = (await axios.get(url)).data;

    if (result.length == 0) {
        return null
    }

    return result as StorageFile;
};

